import ModelDelete from "@/pages/modals/_delete";
import { useDeleteBusinessUnitMutation } from "@/services/businessunit.service";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

export default function Delete() {
    const {t} = useTranslation()
    const location = useLocation()
    const navigate = useNavigate()
    const [deleteBusinessUnit, {isSuccess}] = useDeleteBusinessUnitMutation()

    const onAccept = () => {
        deleteBusinessUnit(location.state?.id || "")
    }

    useEffect(() => {
        if (isSuccess) {
            navigate(location, {state: {reload: true}})
        }
    }, [isSuccess])
    
    return <ModelDelete title={t("modal.delete_business_unit")} content={t("modal.delete_business_unit_content")} onAccept={onAccept} />
}